import { Form } from 'formik'
import styled from 'styled-components'

import { Body, Heading2 } from 'components/Typography'
import { style } from 'theme'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  padding-bottom: 50px;
`

export const Title = styled(Heading2)`
  font-size: 22px;
  line-height: 30px;
  color: ${style(theme => theme.colors.slate)};
  margin: 0 auto 10px;
  max-width: 450px;
  text-align: center;
`

export const Text = styled(Body)`
  font-size: 14px;
  line-height: 22px;
  margin: 0 auto 20px;
  color: ${style(theme => theme.colors.slate)};
  max-width: 450px;
  text-align: center;
`

export const Image = styled.img`
  display: block;
  margin: 30px auto 20px;
`

export const FormContainer = styled(Form)`
  position: relative;
  width: 315px;
  margin: 0 auto 80px;
  box-shadow: 0px 3px 15px 2px rgba(0, 0, 0, 0.05);
  border-radius: 10px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    width: 100%;
    margin-bottom: 60px;
  }
`

export const AccountWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid ${style(theme => theme.colors.ivory)};
  cursor: pointer;
`

export const AccountName = styled(Body)`
  color: ${style(theme => theme.colors.slate)};
  line-height: 22px;
  font-weight: 600;
  text-align: left;
`

export const AccountDetails = styled.p`
  color: ${style(theme => theme.colors.stone)};
  font-size: 12px;
  line-height: 16px;
  margin: 0;
  text-align: left;
`

export const CheckIcon = styled.img`
  width: 22px;
  height: 22px;
  margin: 0 0 0 auto;
`

export const UncheckedIcon = styled.div`
  width: 22px;
  height: 22px;
  margin: 0 0 0 auto;
  background: ${style(theme => theme.colors.white)};
  border: 1px solid ${style(theme => theme.colors.stoneLight)};
  border-radius: 50%;
`

export const FormError = styled.span`
  color: ${style(theme => theme.colors.red)};
  display: block;
  font-size: 12px;
  font-weight: 300;
  left: 0;
  line-height: 1.57;
  margin-bottom: 0;
  margin-top: 8px;
  position: absolute;
`

export const StyledBody = styled(Body)`
  text-align: center;
  max-width: 450px;
  margin: 0 auto 20px;
`

export const Link = styled(Body)`
  color: ${style(theme => theme.colors.green)};
  text-decoration: none;
  cursor: pointer;
  margin-top: 20px;
  font-weight: 600;
`

export const BankImageContainer = styled.img`
  width: 50px;
  height: 50px;
  margin-right: 15px;
`
